// ==============================|| OVERRIDES - TABS (underline tabs) ||============================== //

export default function Tabs(theme) {
  return {
    MuiTabs: {
      styleOverrides: {
        root: { minHeight: 44, borderBottom: `1px solid ${theme.vars.palette.grey[200]}` },
        indicator: { height: 2, borderRadius: 2 },
        vertical: { overflow: 'visible' }
      }
    }
  };
}
